import { useDispatch, useSelector } from "react-redux";
import {
  EditListIcon,
  InfoIcon,
  ShowEye,
} from "../../../../assets/images/svg/svg";
import { formatAmount, renderStatus } from "../../../../Utils/CommonUtils";
import dateFormat from "dateformat";
import rootReducer from "../../../../store";
import {
  editModal,
  openModal,
  updateRendererFormState,
} from "../../../../slices/common/reducer";
import {
  setEditManualPaymentModalDropdown,
  setHandleManualPaymentModal,
} from "../../../../slices/orders/orderSlice";
import {
  downloadFileFromURL,
  saveManualPaymentMode,
  updateManualPaymentById,
} from "../OrderService";
import { downloadDocument } from "../../../../Utils/CommonService";

function useTransactionColumns(handleSplitInfoModalOpen) {
  const dispatch = useDispatch();

  const transactionColumn = [
    {
      header: "Transaction Code",
      accessorKey: "code",
      cell: (props) => (props?.getValue() ? props?.getValue() : "-"),
      size: 150,
    },
    {
      header: "Transaction Id",
      accessorKey: "txn_id",
      cell: (props) => (props?.getValue() ? props?.getValue() : "-"),
      size: 150,
    },
    {
      header: "Payment Mode",
      accessorKey: "mode",
      cell: (props) => (props?.getValue() ? props?.getValue() : "-"),
      size: 150,
    },
    {
      header: "Order Id",
      accessorKey: "order_id",
      cell: (props) => (props?.getValue() ? props?.getValue() : "-"),
      size: 150,
    },
    {
      header: "Amount",
      accessorKey: "amount",
      cell: (props) => (props?.getValue() ? props?.getValue() : "-"),
      size: 150,
    },

    {
      header: "Date",
      accessorKey: "payment_date",
      cell: (props) => (props?.getValue() ? props?.getValue() : "-"),
      size: 150,
    },

    {
      header: "Attachment",
      accessorKey: "file_name",
      cell: (props) => {
        const { file_name, payment_slip_media_id } = props.row.original;
        return file_name ? (
          <span
            style={{
              cursor: "pointer",
              textDecoration: "underline",
              textDecorationColor: "blue",
            }}
            onClick={() => downloadDocument(payment_slip_media_id, file_name)}
          >
            {file_name}
          </span>
        ) : (
          "-"
        );
      },
      size: 150,
    },

    {
      header: "Status",
      accessorKey: "payment_status",
      cell: (props) =>
        props?.getValue() ? renderStatus(props?.getValue()) : "-",
      size: 150,
    },
    {
      header: "Action",
      accessorKey: "",
      cell: (props) => {
        const { payment_type, payment_status, entityid } = props.row.original;

        return (
          <>
            <span onClick={() => handleSplitInfoModalOpen(entityid)}>
              <InfoIcon />
            </span>

            {payment_type === "MANUAL_PAYMENT" &&
              payment_status !== "Success" && (
                <span
                  style={{ margin: "10px", cursor: "pointer" }}
                  onClick={() => {
                    dispatch(setEditManualPaymentModalDropdown(true));
                    dispatch(setHandleManualPaymentModal(true));
                    updateManualPaymentById(entityid, "PMT");
                  }}
                >
                  <EditListIcon />
                </span>
              )}

            {payment_type === "MANUAL_PAYMENT" &&
              payment_status === "Success" && (
                <span
                  style={{ margin: "10px", cursor: "pointer" }}
                  onClick={() => {
                    dispatch(setHandleManualPaymentModal(true));
                    // dispatch(setEditManualPaymentModalDropdown(true));
                    updateManualPaymentById(entityid, "PMT");
                  }}
                >
                  <ShowEye />
                </span>
              )}
          </>
        );
      },
      size: 100,
    },
  ];

  return { transactionColumn };
}

export default useTransactionColumns;
